import { useNavigate } from 'react-router-dom';
import { useProjects } from '@features/projects';
import { ProjectList } from '@widgets/projects/project-list';
import type { ProjectDto } from '@shared/api/contracts';
import { CabinetListPageSkeleton } from '@shared/ui';

export function ProjectsPage() {
  const navigate = useNavigate();
  const { projects, isLoading } = useProjects();

  const handleEdit = (project: ProjectDto) => {
    navigate('/projects/add', { state: { project } });
  };

  const handleAdd = () => {
    navigate('/projects/add');
  };

  if (isLoading && !projects.length) {
    return <CabinetListPageSkeleton />;
  }

  return (
    <ProjectList
      projects={projects}
      isLoading={false}
      onEdit={handleEdit}
      onAdd={handleAdd}
    />
  );
}
